module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av646-283eafe3713d226e37fc2bfb0b9090e4.jpg";